<template>
  <div class="Node5Settings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="Node5Settings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="Node5Settings-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node2Settings_title1}}
        </template>
        <template v-slot:body>
          <div class="Node5Settings-wrapper-colors lxn-w100">
            <div @click="activeBoxIndex = 0;" class="Node5Settings-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
              <div class="Node5Settings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 1;" class="Node5Settings-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
              <div class="Node5Settings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 2;" class="Node5Settings-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
              <div class="Node5Settings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 3;" class="Node5Settings-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
              <div class="Node5Settings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 4;" class="Node5Settings-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
              <div class="Node5Settings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
          </div>
          <div class="Node5Settings-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            {{$store.getters.language.texts.Node2Settings_text1}}
          </div>
          <div class="lxn-w100">
            <customInput @focus="inputState='active'" @blur="inputState=''" :inputState="inputState" v-model="NodeName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddNodeNameColor_placeHolder" inputType="text" />
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node2Settings_title2}}
        </template>
        <template v-slot:body>
          <div class="Node5Settings-wrapper-deviceName lxn-w100 lxn-title lxn-text-en lxn-text-center">
            {{deviceName}}
          </div>
          <div class="Node5Settings-wrapper-status">
            <div class="Node5Settings-wrapper-status-d0 lxn-text" :class="[$store.getters.language.floatClass, $store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.Node2Settings_deviceStatus}}
            </div>
            <div class="Node5Settings-wrapper-status-d1" :class="[$store.getters.language.floatClassReverse]">
              <ButtonIcon :size="40" bgColor="#DEDEDE" :icon="connectionStatusIcon" iconColor="#1EA5DE" :padding="8" />
            </div>
            <div v-if="!isNodeOffline" class="Node5Settings-wrapper-status-d1" :class="[$store.getters.language.floatClassReverse]">
              <ButtonIcon :size="40" bgColor="#DEDEDE" :icon="temperatureStatusIcon" iconColor="#1EA5DE" :padding="8" />
            </div>
            <div v-if="!isNodeOffline" class="Node5Settings-wrapper-status-d1" :class="[$store.getters.language.floatClassReverse]">
              <ButtonIcon :size="40" bgColor="#DEDEDE" :icon="rssiStatusIcon" iconColor="#1EA5DE" :padding="8" />
            </div>
          </div>
          <div class="Node5Settings-wrapper-UUID lxn-w100">
            <div class="Node5Settings-wrapper-UUID-d0 lxn-title lxn-text-en" :class="$store.getters.language.floatClass">
              UUID
            </div>
            <div class="Node5Settings-wrapper-UUID-d1 lxn-title lxn-text-en" :class="$store.getters.language.floatClassReverse">
              0X{{uuid}}
            </div>
          </div>
        </template>
      </TitleBox>
      <!-- <TitleBox v-if="isUserOwner" :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node2Settings_title3}}
        </template>
        <template v-slot:body>
          <CustomButton @click="setDefault(0)" bgColor="#1EA5DE" iconLeft="boxArrow" iconLeftColor="#1EA5DE" iconLeftBgColor="#D5E6F0" textColor="#FFFFFF" :iconLeftPadding="8" :useLanguageDirection="true" :smallText="true" :useFontAlign="true">
            {{$store.getters.language.texts.Node3Settings_default3}}
          </CustomButton>
          
        </template>
      </TitleBox> -->
    </div>
    <div class="Node5Settings-button lxn-margin-auto lxn-w100">
      <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.Node2Settings_button}}
      </CustomButton>
    </div>
    <div v-if="isUserOwner" class="Node5Settings-button lxn-margin-auto lxn-w100">
      <CustomButton @click="deleteDevice" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#F5C7BD" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.Node2Settings_button2}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ButtonIcon from '@/components/ButtonIcon.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'
import * as CONFIGS from '@/statics/configs.js'
import NODE17 from '@/statics/devices/Node17/header.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'

export default {
  name: 'Node17Settings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    ButtonIcon
  },
  data: function () {
    return {
      NodeName: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID).name,
      inputState: '',
      activeBoxIndex: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID).color,
    }
  },
  mounted: function () {
    var messagingHook = new Messaging(new Logger(false));
    messagingHook.init({
      psk: this.hub.psk,
      destinationUUID: this.hub.uuid,
      sourceUUID: this.$store.state.user.uuid
    });
    this.$store.dispatch('readNodeParameters', {messagingHook: messagingHook,hubUUID: this.hub.uuid,nodeUUID: this.node.uuid})
    .then( response => {
      this.$store.dispatch('processNodeParameters', {rawParameters: response.body.bodyContent.parameterList, nodeUUID: this.node.uuid});
    })
    .catch( response => {
      if(response.rejectCode == 2){
        this.$store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }
    })
    .finally( () => {
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: true,
      });
    });
  },
  destroyed: function () {
    this.$store.commit('cancelAllStateUpdates');
  },
  computed: {
    node: function () {
      return this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID);
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    isUserOwner: function () {
      return this.hub.isOwner;
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    deviceName: function () {
      return NODE17.NAME;
    },
    uuid: function () {
      return this.node.uuid.toString(16).toUpperCase();
    },
    connectionStatusIcon: function () {
      var connectionStatusIcon = this.node.connectionStatus;
      if(connectionStatusIcon == -1 || connectionStatusIcon == 0){
        connectionStatusIcon = 'offline';
      }else{
        return 'online';
      }
      return connectionStatusIcon;
    },
    rssiStatusIcon: function () {
      var rssiParameterId = NODE17.LORA_RSSI.PARAMETER_ID;
      var snrParameterId = NODE17.LORA_SNR.PARAMETER_ID;
      var rssi = this.$store.getters.getParameterValue(this.node.index, rssiParameterId);
      var snr = this.$store.getters.getParameterValue(this.node.index, snrParameterId);

      return this.$store.getters.getNodeRssiSnrIcon(rssi, snr);
    },
    temperatureStatusIcon: function () {
      var temperatureParameterId = NODE17.TEMPERATURE.PARAMETER_ID;
      var temperature = this.$store.getters.getParameterValue(this.node.index, temperatureParameterId);
      return this.$store.getters.getNodeTemperatureIcon(temperature);
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    saveChanges: function () {
      this.inputState = '';
      if(this.NodeName == ''){
        this.inputState = 'error';
        alert(this.$store.getters.language.texts.Node2Settings_alert);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.commit('setNodeName', {nodeIndex: this.node.index, name: this.NodeName})
        this.$store.commit('setNodeColor', {nodeIndex: this.node.index, color: this.activeBoxIndex})
        this.$store.commit('saveState');
        this.$router.push('/Home/Devices');
        this.$store.commit('setAppBusy', false);
      }
    },
    setDefault: function (index) {
      this.$store.commit('setAppBusy', true);
      var psk = this.hub.psk;
      var destinationUUID = this.hub.uuid;
      var nodeUUID = this.node.uuid;
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: psk,
        destinationUUID: destinationUUID,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('setInstructionsOnDevice', {
        messagingHook: messagingHook,
        hubUUID: destinationUUID,
        nodeUUID: nodeUUID,
        instructions: NODE17.DEFAULT_INSTRUCTIONS[index]
      }).then( () => {
          this.$router.push('/Node2SettingsSuccess');
          this.$store.commit('setAppBusy', false)
        }
      ).catch( response => {
        if(response.rejectCode == 1){
          this.$router.push('/SettingsNodeError');
        }else if(response.rejectCode == 2){
          this.$router.push('/SettingsHubError');
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }else{
          this.$router.push('/SettingsHubError');
        }
        this.$store.commit('setAppBusy', false);
      })
    },
    deleteDevice: function () {
      this.$router.push('/DeleteDevice/' + this.node.uuid);
    },
  }
}
</script>

<style>
  .Node5Settings-topCurve-wrapper {
    height: 200px;
  }
  .Node5Settings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .Node5Settings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .Node5Settings-wrapper-colors {
    height: 50px;
  }
  .Node5Settings-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .Node5Settings-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .Node5Settings-color.active .Node5Settings-selectedColor {
    opacity: 1;
  }
  .Node5Settings-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .Node5Settings-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .Node5Settings-wrapper-deviceName {
    height: 30px;
    line-height: 30px;
    color: #53636C;
  }
  .Node5Settings-wrapper-UUID {
    height: 30px;
    color: #53636C;
    margin-top: 14px;
  }
  .Node5Settings-wrapper-UUID-d0 {
    letter-spacing: 2px;
    line-height: 30px;
  }
  .Node5Settings-wrapper-UUID-d1 {
    letter-spacing: 3px;
    line-height: 30px;
  }
  .Node5Settings-wrapper-status {
    height: 50px;
    margin-top: 14px;
  }
  .Node5Settings-wrapper-status-d0 {
    line-height: 50px;
  }
  .Node5Settings-wrapper-status-d1 {
    padding-top: 5px;
    margin-right: 10px;
  }
	.Node5Settings-st0 {
    fill: #ECECEC;
  }
	.Node5Settings-st1 {
    fill: #53636C;
  }
	.Node5Settings-st2 {
    fill: #1EA5DE;
  }
</style>
